import {Layout} from "../../../src/ts/layouts/Layout";

export class Videolink extends Layout {

    private readonly SELECTOR_VIDEOLINK: string = '.videoLink__link';
    private readonly SELECTOR_OVERLAY: string = '.videoLink__overlay';
    private readonly SELECTOR_OVERLAY_CLOSE_BUTTON: string = '.videoLink__overlay__close-btn';
    private readonly SELECTOR_OVERLAY_VIDEOCONTAINER: string = '.videoLink__overlay__video-container';

    private readonly OVERLAY_OPEN_CLASS: string = 'overlay_open';


    private $overlay: JQuery;
    private $overlayCloseBtn: JQuery;
    private $iframe: JQuery;

    constructor($elem: JQuery) {
        super($elem);

        this.$overlay = this.$layout.find(this.SELECTOR_OVERLAY);
        this.$overlayCloseBtn = this.$overlay.find(this.SELECTOR_OVERLAY_CLOSE_BUTTON);

        this.$iframe = this.$overlay.find('iframe');


        this.$layout.find(this.SELECTOR_VIDEOLINK).on('click', (e) => this.onVideoLinkClick(e));
        this.$overlayCloseBtn.on('click', (e) => this.onCloseOverlay(e));
        this.$overlay.on('click', (e) => this.onCloseOverlay(e));

    }

    private onVideoLinkClick(e: JQuery.ClickEvent) {

        $('body').addClass(this.OVERLAY_OPEN_CLASS);
        this.$overlay.addClass(this.OVERLAY_OPEN_CLASS);
        const videoUrl = this.$iframe.data('video-url');
        this.$iframe.attr('src', videoUrl);
        return false;
    }

    private onCloseOverlay(e: JQuery.ClickEvent) {


        $('body').removeClass(this.OVERLAY_OPEN_CLASS);
        this.$overlay.removeClass(this.OVERLAY_OPEN_CLASS);
        this.$iframe.attr('src', '');
        this.$iframe.remove();

        this.$overlay.find(this.SELECTOR_OVERLAY_VIDEOCONTAINER + ' .video-embed').append(this.$iframe);

        return false;
    }


}

